import { render, staticRenderFns } from "./enterEmail.vue?vue&type=template&id=0bdb8a5d&scoped=true&"
import script from "./enterEmail.vue?vue&type=script&lang=js&"
export * from "./enterEmail.vue?vue&type=script&lang=js&"
import style0 from "./enterEmail.vue?vue&type=style&index=0&id=0bdb8a5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdb8a5d",
  null
  
)

export default component.exports